<template>
   <div>
     
   <transition name="zoom">
   <div v-if="showing" id="modal-receta-2" >
   
   
      <div class="main-cont">
         <div v-on:click="hide();" class="contenedor-icono-2">       
               <b-icon class="icon" icon="x"></b-icon>
            </div>
         <div class="header-m">
   
   
   
         </div>
         <div  class="body-m" style="text-align:  left; width:100%;">
            <div v-if="status==0">
              <!-- Step 1: Basic Info -->
              <div v-if="current_step === 1">
                <div class="titulo1">Crear nuevo profesional - Paso 1 de 2</div>
                <div class="main-txt">
                  <table style="margin:0 auto;">
                    <tr>
                      <td>Nombre</td>
                      <td> <input v-model="nombre_" type="text"></td>
                    </tr>
                    <tr>
                      <td>Apellido</td>
                      <td> <input v-model="apellido_" type="text"></td>
                    </tr>
                    <tr>
                      <td>Email</td>
                      <td> <input v-model="email_" type="text"></td>
                    </tr>
                    <tr>
                      <td>Telefono</td>
                      <td> <input v-model="telefono_" type="text"></td>
                    </tr>
                    <tr>
                      <td>Rut</td>
                      <td> <input v-model="rut_" type="text"></td>
                    </tr>
                  </table>
                </div>
              </div>

              <!-- Step 2: Commission Info -->
              <div v-if="current_step === 2">
                <div class="titulo1">Configuración de Comisión - Paso 2 de 2</div>
                <div class="main-txt">
                  <hr class="my-3">
                  <h5 class="mb-3">Configuración de Comisión</h5>
                  <div class="mb-3">
                    <label class="form-label">Tipo de Comisión:</label>
                    <div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" id="flatRate" value="flat" v-model="commission_type">
                        <label class="form-check-label" for="flatRate">Tasa Fija</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" id="tieredCommission" value="tier" v-model="commission_type">
                        <label class="form-check-label" for="tieredCommission">Tramos de Comisión</label>
                      </div>
                    </div>
                  </div>

                  <div v-if="commission_type === 'flat'" class="mb-3">
                    <label for="flatCommissionRate" class="form-label">Tasa de Comisión Fija (0.0 - 1.0):</label>
                    <input type="number" class="form-control" id="flatCommissionRate" v-model.number="flat_commission_rate" step="0.01" min="0" max="1">
                  </div>

                  <div v-if="commission_type === 'tier'">
                    <h6>Tramos de Comisión:</h6>
                    <div v-for="(tier, index) in commission_tiers" :key="index" class="row mb-2 align-items-end">
                      <div class="col-md-3">
                        <label class="form-label-sm d-block">Límite Superior:</label>
                        <input type="number" class="form-control form-control-sm" v-model.number="tier.threshold_upper" placeholder="Ej: 100000">
                      </div>
                      <div class="col-md-2">
                        <label class="form-label-sm d-block">Tasa (0.0-1.0):</label>
                        <input type="number" class="form-control form-control-sm" v-model.number="tier.rate" step="0.001" placeholder="Ej: 0.2">
                      </div>
                      <div class="col-md-5">
                        <label class="form-label-sm d-block">Descripción:</label>
                        <input type="text" class="form-control form-control-sm" v-model="tier.description" placeholder="Ej: Hasta 100,000 CLP">
                      </div>
                      <div class="col-md-2 text-end">
                        <button v-if="commission_tiers.length > 1" @click="removeTier(index)" class="btn btn-danger btn-sm">Eliminar</button>
                      </div>
                    </div>
                    <button @click="addTier" class="btn btn-success btn-sm mt-2 mb-3">Agregar Tramo</button>
                  </div>
                </div>
              </div>

              <!-- Action Buttons Container -->
              <div style="text-align: center; margin-top: 20px;">
                <button v-if="current_step === 1" @click="nextStep()" :class="{'disable': puedeContinuarPaso1 != ''}" class="btn-agregar">Continuar</button>

                <button v-if="current_step === 2" @click="prevStep()" class="btn-agregar" style="background-color: #6c757d; margin-right: 10px;">Volver</button>
                <button v-if="current_step === 2" @click="enviar()" :class="{'disable': puedeContinuarPaso2 != ''}" class="btn-agregar">Crear Profesional             <div
             
              class="spinner-border spinner-border spinner-border-sm"
              style="
                margin-left: 10px;
                margin-right: 14px;
                margin-top: 2px;
                margin-bottom: 2px;
                color: #fff;
              "
              v-if="loading"
              role="status"
            ></div></button>
               </div>
            </div>
            <div v-else-if="status == 1">
               <div class="titulo1">¡Exito!</div>
            <div class="main-txt">
               ¡El profesional se ha creado! Sus credenciales han sido enviadas por email.
            </div>

            </div>
            <div v-else-if="status == 2">
               <div class="titulo1">¡ERROR!</div>
            <div class="main-txt">
               Ha habido un error al crear el profesional.
            </div>

            </div>
               
    

      
         </div>
   


      </div>
   
   </div>
   
   </transition>
   </div>
   </template>
   
   <script>
   import {mapActions, mapGetters} from 'vuex';
   import axios from 'axios'
   
   export default {
     name: 'ModalNuevoProfesional',
     components: {
   
     },
     props: {
      //profesional_: Object,
     },
     data(){
       return {
         nombre_:'',
         apellido_:'',
         telefono_:'',
         email_:'',
         rut_:'',

       commission_type: 'tier', // 'flat' or 'tier'
       flat_commission_rate: 0,
       commission_tiers: [
         {
            "rate":0.2,
            "description":"Up to 100,000 CLP",
            "threshold_upper":100000
         },
         {
            "rate":0.175,
            "description":"From 100,001 to 300,000 CLP",
            "threshold_upper":300000
         },
         {
            "rate":0.15,
            "description":"From 300,001 to 600,000 CLP",
            "threshold_upper":600000
         },
         {
            "rate":0.125,
            "description":"From 600,001 to 1,000,000 CLP",
            "threshold_upper":1000000
         },
         {
            "rate":0.1,
            "description":"Over 1,000,000 CLP",
            "threshold_upper":2000000
         }
       ],

         loading:false,
         showing:false,
       status: 0, // 0: input, 1: success, 2: error
       current_step: 1, // 1: basic info, 2: commission info
       }
     },
     methods:{
   
      ...mapActions(['setProfesionalAction']),
   
      enviar(){
         if(this.puedeContinuarPaso1 != '' || this.puedeContinuarPaso2 != '')
            return;
      this.loading = true;
      axios.post(window.hostname+'api/admin/crear_profesional',
      {
         nombre:this.nombre_,
         apellido:this.apellido_,
         telefono:this.telefono_,
         email:this.email_,
         rut:this.rut_,
         commission_type: this.commission_type,
         flat_commission_rate: this.commission_type === 'flat' ? this.flat_commission_rate : null,
         commission_tiers: this.commission_type === 'tier' ? this.commission_tiers.sort((a, b) => a.threshold_upper - b.threshold_upper) : null,
      })
      .then(r=>{
         this.status = 1;
         this.loading = false;
         this.$root.$emit('update-profesionales');

      })
      .catch(e=>{
         this.status = 2;
         this.loading = false;

      }); 

      },

      verificar_rut(r)
    {
      function dv(T){
        var M=0,S=1;
        for(;T;T=Math.floor(T/10))
          S=(S+T%10*(9-M++%6))%11;
        return S?S-1:'k';
      }
    function validaRut (rutCompleto) {
        if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test( rutCompleto ))
          return false;
        var tmp 	= rutCompleto.split('-');
        var digv	= tmp[1]; 
        var rut 	= tmp[0];
        if ( digv == 'K' ) digv = 'k' ;
          return (dv(rut) == digv ) ? true : false;
      }
      return validaRut(r)
    },
      verificar_correo(c){
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(c != '')
        return re.test(c) ? true: false;
      return false;
    },

   
       show(){
         this.showing = true;
         this.status = 0; // Reset status to input mode
         this.current_step = 1; // Always start at step 1

         // Clear basic info fields
         this.nombre_ = '';
         this.apellido_ = '';
         this.telefono_ = '';
         this.email_ = '';
         this.rut_ = '';

         // Reset commission fields to default
         this.commission_type = 'tier';
         this.flat_commission_rate = 0;
         this.commission_tiers = [
            { rate: 0.2, description: "Up to 100,000 CLP", threshold_upper: 100000 },
            { rate: 0.175, description: "From 100,001 to 300,000 CLP", threshold_upper: 300000 },
            { rate: 0.15, description: "From 300,001 to 600,000 CLP", threshold_upper: 600000 },
            { rate: 0.125, description: "From 600,001 to 1,000,000 CLP", threshold_upper: 1000000 },
            { rate: 0.1, description: "Over 1,000,000 CLP", threshold_upper: 2000000 }
         ];
         this.loading = false;
       },
       hide(){
         this.showing = false;
         // Optionally reset status and step here too, though show() will handle it on next open.
         // this.status = 0;
         // this.current_step = 1;
         // this.servicio_id = -1; // This seems specific to another context, keeping if relevant
       },
      addTier() {
        this.commission_tiers.push({ threshold_upper: null, rate: null, description: '' });
      },
      removeTier(index) {
        if (this.commission_tiers.length > 1) { // Ensure at least one tier remains
          this.commission_tiers.splice(index, 1);
        }
     },
      nextStep() {
        // Validation for step 1 will be handled by :class binding on the button
        // For now, just check if puedeContinuarPaso1 (which we will create) is empty
        if (this.puedeContinuarPaso1 === '') {
          this.current_step = 2;
        } else {
          // Optionally, alert the user or rely on button class to show it's disabled
          alert(this.puedeContinuarPaso1);
        }
      },
      prevStep() {
        this.current_step = 1;
      }
   
   
     },
     mounted(){
   
   
   
   
      
     },
     created(){
   
     
     },
     computed:{
      ...mapGetters(['agregando_servicio_id', 'servicios', 'servicio_selected']),
    puedeContinuarPaso1(){
         if(this.nombre_.length  == 0 || !this.nombre_)
        return 'Debes ingresar un nombre.' 
        if(this.telefono_.length < 4)
        return 'Por favor, ingresa un teléfono valido.'
      if(this.apellido_.length == 0)
        return 'Debes ingresar un apellido.' 
         if(!this.verificar_correo(this.email_))
         return 'Debes ingresar un correo valido.'
         if(!(this.verificar_rut(this.rut_)))
           return 'Tiene que tener un rut válido.'
      return ''
    },
    puedeContinuarPaso2(){
      if (this.commission_type === 'flat') {
        if (typeof this.flat_commission_rate !== 'number' || this.flat_commission_rate < 0 || this.flat_commission_rate > 1) {
          return 'La tasa de comisión fija debe ser un número entre 0 y 1.';
        }
      } else if (this.commission_type === 'tier') {
        if (!this.commission_tiers || this.commission_tiers.length === 0) {
          return 'Debe definir al menos un tramo de comisión.';
        }
        // Ensure tiers are sorted for validation if manual input order isn't guaranteed
        const sortedTiers = [...this.commission_tiers].sort((a,b) => a.threshold_upper - b.threshold_upper);

        for (let i = 0; i < sortedTiers.length; i++) {
          const tier = sortedTiers[i];
          if (tier.threshold_upper === null || typeof tier.threshold_upper !== 'number' || tier.threshold_upper <= 0) {
            return `El límite superior del tramo ${i + 1} debe ser un número positivo.`;
          }
          if (tier.rate === null || typeof tier.rate !== 'number' || tier.rate < 0 || tier.rate > 1) {
            return `La tasa del tramo ${i + 1} debe ser un número entre 0 y 1.`;
          }
          if (!tier.description || tier.description.trim() === '') {
            return `La descripción del tramo ${i + 1} no puede estar vacía.`;
          }
          if (i > 0 && tier.threshold_upper <= sortedTiers[i-1].threshold_upper) {
            // This check might be redundant if tiers are always added/sorted correctly,
            // but good for safety if direct manipulation or unsorted additions were possible.
            return `El límite superior del tramo ${i + 1} (${tier.threshold_upper}) debe ser mayor que el del tramo anterior (${sortedTiers[i-1].threshold_upper}). Los tramos deben estar ordenados.`;
          }
        }
      }
      return ''
    }
   
     },
     watch:{

     
     },
   }
   </script>
   
   
   
   <style scoped>
   td{
      padding: 5px !important;
   }
   /* Custom styling for modal buttons to make them more rounded */
   .main-cont .btn-sm {
     border-radius: 6px; /* More rounded corners for sm buttons in this modal */
   }
   .disable{
      background-color: rgb(148, 148, 148) !important;

   }
   .main-txt{
      text-align: center;
      padding: 20px;
   }
   .left-dv, .right-dv{
      display: inline-block;
      
      width: 50%;
      text-align: center;
      height:80px;

   }
   .right-dv{
      display: inline-block;
   }
   .calificacion{
      display: grid;
      grid-template-columns: repeat(8, 1fr);
      
   
   }

   .empresa-link{
     display: inline-block;
     color:#ffac46;
   }
   .medalla-cont{
     margin-bottom: 8px;
   }
   .medallas{
     margin-bottom: 20px;
   }
   .icons-desc{
     margin-right: 10px;
   }
   .star{
     cursor: pointer;
     margin-right:4px;
     height:18px;
     width: 18px;
     color:#DAA520;
     /*color:#DAA520;*/
   }
   .titulo-perfil{
      font-size: 25px;
     font-weight: 700;
     margin-top:10px;
     margin-bottom: 25px;
     color:rgb(46, 44, 54);
     font-weight: 700;
   }
   .about-cont{
      padding: 20px;
   }
   .titulo1{
      color:rgb(46, 44, 54);
     font-weight: 700;
     margin-bottom: 10px;
     text-align: center;
     font-size: 27px;
     padding: 10px;
   }
   
   .coment-grid{
      display: grid;  
   
      grid-template-columns: repeat(6, 1fr);
      
   
   }
   .coment-l{
      grid-column:  1 / 2; 
      text-align: left;
      min-width: 145px;
      
      
   }
   .coment-r{
      grid-column:  2 / 7; 
      padding-left: 40px;
      
      
   }
   .coment-r .titulo1{
      margin-bottom:30px;   
   }
   .coment-l .titulo1{
      margin-bottom:30px;   
   }
   .perfil-cont{
      display: grid;  
      padding:20px;
      grid-template-columns: repeat(6, 1fr);
   
   }
   .perfil-cont-l{
      grid-column:  1 / 2; 
      
   }
   .perfil-cont-l img{
      height: 150px;
      width: 150px;
      border-radius: 100%;
   }
   .perfil-cont-r{
      padding-left:20px;
      grid-row:1;
     grid-column:  2 / 7; 
   
   }
   .separador{
     width: Calc(100% - 40px);
   
      margin: 20px auto;
     
     border-bottom: 1px solid rgb(240, 240, 240);
   }
   .cont-outer{
      padding: 10px;
   }
   .info-cont{
      padding:10px;
     
      border-radius: 10px;
   }
   .desc-titulo{
    color:rgb(46, 44, 54) !important;
    font-weight: 700;
    font-size: 20px;
    padding: 0px 0px 0px 20px;
    
   }
   .grid-right-container{
      border-right: 1px solid rgb(240, 240, 240);
      margin-top:30px;
      margin-right:20px;
      margin-bottom:20px;
   }
   .desc-body{
      padding: 20px 20px;
   
   }
   .desc-img{
      border-radius: 30px;
      width: auto;
      margin: 0 auto;
      max-height: 300px;
      max-width: 100%;
   }
   .desc-img-cont{
      padding: 20px 20px;
      
   }
   .caract-titulo{
      color: rgb(46, 44, 54) !important;
      font-weight: 700;
      padding: 20px 0px;
   }
   .caract-item{
      font-size: 16px !important;
   }
   .grid-left{
      grid-area: r;
      min-width: 400px;
      margin-left:20px;
      padding:10px 20px;
      
   }
   .grid-right{
      grid-area: l;
   
   }
   .precio-container{
      display: inline-block;
      margin-right: 20px;
   }
   .btn-agregar{
      text-align: center;
      width:240px;
      outline: none;
      border: none;
      display: inline-block;
      padding: 15px 24px;
      font-weight: 700;
      color:#fff;
      background-color: rgb(255,140,0);
      vertical-align: middle;
      border-radius: 8px;
      line-height: 20px;
      transition: .3s;
   }
   .btn-agregar:hover{
      background-color: rgba(255, 140, 0, 0.774);
   }
   .desactivado{
      color:rgb(170, 170, 170);
      background-color: rgb(240,240,240);
      cursor: not-allowed;
   
   }
   .body-m::-webkit-scrollbar-thumb {
     background-color: #d6dee1 !important;
     border-radius: 20px !important;
     border: 6px solid transparent !important;
     background-clip: content-box !important;
   }
   .body-m::-webkit-scrollbar {
     width: 20px;
   }
   
   .body-m::-webkit-scrollbar-track {
     background-color: transparent;
   }
   
   .body-m::-webkit-scrollbar-thumb {
     background-color: #d6dee1;
     border-radius: 20px;
     border: 6px solid transparent;
     background-clip: content-box;
   }
   
   .body-m::-webkit-scrollbar-thumb:hover {
     background-color: #a8bbbf;
   }
   /* Create a custom radio button */
   .footer-m{
   height:70px;
   border-top: 1px solid rgba(160, 160, 160, 0.2);
   padding-top:15px;
   
   }
   .footer-options{
      vertical-align: middle;
      
   }
   .header-m{
      text-align: left; 
      color:rgb(46, 44, 54);
      font-weight: 800;
      font-size: 24px; 
      padding: 10px 20px;
      width:100%;
      display: block;
      height:50px;
      line-height: 65px;
   
      position: relative;
   
   }
   .body-m{
      overflow-y: scroll;
      /* Adjust height calculation if needed, or ensure it fills available space */
      /* For now, let's assume it expands naturally within the new modal height.
         If specific height is needed, it would be:
         height: Calc(100% - 50px - 70px); /* Modal height - header height - footer height */
      /* Let's add some padding at the bottom */
      padding-bottom: 20px;
   }
   
   .bg-negro{
     height: 133vh;
     width: 133vw;
     position: fixed;
     background: rgba(0,0,0,0.2);
     /* backdrop-filter: blur(1px);*/
     z-index: 9999;
   
   }
   .main-cont{
      position: relative;   
   }
   
   #modal-receta-2{
      line-height: 16px;
      transition: 1s;
      position:fixed;
      /* Increased height, and using min-height for flexibility */
      min-height:550px;
      max-height: 90vh; /* Ensure it doesn't exceed viewport height */
    
      overflow-y:auto; /* This will be handled by .body-m if content overflows */
      border-radius:6px;
      box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; 
      background:white; 
      top: 50%;
      left:0px;
       transform: translateY(-50%);
     
      width:Calc(850px); /* Increased width */
      max-width:95%; /* Adjusted max-width to be relative for better responsiveness */
      margin: 0px auto; 
      right: 0;
      opacity:1;
      z-index:99999;
   }
   
   
   .cont{
     text-align: center;
     vertical-align: middle;
     position:absolute;
      width:Calc(100% - 40px);
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
   }
   #modal-receta-2 .icon{
      height:30px; width:30px; color:white;  
   }
   #modal-receta-2 .contenedor-icono-2{
      cursor:pointer;
      position:absolute;
      right:20px;
      top:30px;
      transform: translateY(-50%);
      height:30px;
      width:30px;
      background-color:rgb(100, 100, 100);
      border-radius:50px;
      z-index: 100001;
   }
   
   @media only screen and (max-width: 370px) {
      .calificacion{
      display: inherit !important;
      grid-template-columns: none;
      
   
   }
   .calificacion-l-stars{
      margin-bottom: 10px;
   }
   .calificacion-l-nombre{
      font-size: 16px !important;
      padding: 5px 0px !important;
   
   }
   .calificacion-l{
      grid-column:  1 / 3; 
      text-align: center !important;
      padding: 0px;
         
      
   }
   .calificacion-l .star{
      height: 16px !important;
      width: 16px !important;
      margin-right:2px;
      
      
   }
   .calificacion-l img{
      height:80px;
      width: 80px;
      border-radius: 100%;
   }
   .calificacion-r{
      grid-column:  3 / 9; 
   
      line-height: 100%;
      display: flex;
   
   align-items: center; /* Align vertical */
      
   
      
   }
   .calificacion-r-txt{
      text-align: center;
      
   
   }
   
   
   
   }
   @media only screen and (max-width: 580px) {
   
   
   
      .info-cont{
      padding:10px;
     
      border-radius: 10px;
   }
      .perfil-cont{
      display: inherit;  
      padding:10px;
      text-align: center;
   
   }
   .perfil-cont-r{
      padding-left:0px;
   
   
   }
   .about-cont{
      padding: 5px;
   }
   .cont-outer{
   padding: 0px;
   }
   .perfil-cont-l{
      grid-column:  none;
      margin-bottom: 20px; 
      
   }
   .perfil-cont-l img{
      height: 180px;
      width: 180px;
      border-radius: 100%;
   }
   .perfil-cont-r{
      padding-left:0px;
      grid-row:none;
     grid-column:  none;
     text-align: left; 
   
   }
   
   }
   @media only screen and (max-width: 500px) {
   
      .calificacion{
      display: grid;
      grid-template-columns: repeat(8, 1fr);
      
   
   }
   .calificacion-l-nombre{
      font-size: 14px;
      padding: 10px 0px;
   
   }
   .calificacion-l{
      grid-column:  1 / 3; 
      text-align: left;
      padding: 0px;
         
      
   }
   .calificacion-l .star{
      height: 10px;
      width: 10px;
      margin-right:2px;
      
      
   }
   .calificacion-l img{
      height:80px;
      width: 80px;
      border-radius: 100%;
   }
   .calificacion-r{
      grid-column:  3 / 9; 
   
      line-height: 100%;
      display: flex;
   
   align-items: center; /* Align vertical */
      
   
      
   }
   .calificacion-r-txt{
      vertical-align: middle;
     justify-content: center;
      
   
   }
   }
   @media only screen and (max-width: 740px) {
   
   
      .coment-grid{
      display: inherit;  
   
      grid-template-columns: repeat(6, 1fr);
      
   
   }
   .coment-l{
      grid-column: none; 
      text-align: left;
      min-width: 145px;
      
      
   }
   .coment-r{
      grid-column: none; 
      padding-left: 0px;
      margin-top: 40px;
      
      
   }
   }
   
   @media only screen and (max-width: 1000px) {
   
      .zoom-enter-active,
   .zoom-leave-active {
     animation-duration: 0.0s;
     animation-fill-mode: both;
     animation-name: zoom;
   }
   
   .zoom-leave-active {
     animation-direction: reverse;
   }
      .grid-left{
      grid-area: r;
      min-width: 00px;
      padding-bottom:60px;
   }
   .precio-container{
      display: inline-block;
      margin-right: 10px;
   }
   .grid-right-container{
      border-right: none;
      margin-top:30px;
      margin-right:0px;
      margin-bottom:0px;
      border-bottom: 1px solid rgb(240, 240, 240);
   }
   
   .footer-m{
      position: fixed;
      bottom:0px;
      width:100%;
      background-color: #fff;
      padding-top:10px;
      height:70px;
   
   }
   
   
   #modal-receta-2{
      
      position:fixed !important;
      height:Calc(133vh) !important;
      border-radius:0px;
      box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; 
      padding:0px; 
      background:white; 
      top:0px !important;
      width: 133vw !important;
      transform: none !important;
      max-width:100%;
      max-height: 100%;
      margin: 0px auto !important; 
      left: 0px !important;
      right: 0px !important;
      opacity:1;
      z-index:90001;
      transition:0s;
   }
   
   .body-m{
      overflow-y: scroll;

      height:Calc(133vh - 50px);
      padding-bottom: 60px;

      
   }
   .left-dv, .right-dv{
      height:100%;
   }
   .main-cont{
      
      
   }
   
   
   
   }
   
   .zoom-enter-active,
   .zoom-leave-active {
     animation-duration: 0.1s;
     animation-fill-mode: both;
     animation-name: zoom;
   }
   
   .zoom-leave-active {
     animation-direction: reverse;
   }
   
   @keyframes zoom {
     from {
       opacity: 0;
       transform:  scale3d(0.3, 0.3, 0.3);
     }
   
     100% {
       opacity: 1;
     }
   }
   </style>
   